import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
import { RetryConfig } from "utils/ErrorHandling"
import { CarrotPlanStep } from "types/CarrotPlan"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const ENDPOINT = "GetCarrotPlanStepMenuItem"

export interface CarrotPlanStepMenuItem extends CarrotPlanStep {
  displayText: string
  defaultUrl: string
  mediaText: string
  mediaEntityId: string
  displayUrl: string
}

export default function useCarrotPlanStepMenuItems(
  carrotPlanId: number
): UseQueryResult<CarrotPlanStepMenuItem[], ResponseError> {
  return useQuery<CarrotPlanStepMenuItem[], ResponseError>(
    [ENDPOINT, carrotPlanId],
    () => client.getCarrotPlanStepMenuItems(carrotPlanId),
    {
      ...RetryConfig
    }
  )
}
